export default __webpack_public_path__ + "static/media/refresh.b22ed17f.svg";